import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { removeWorkspaceMember } from '../../../api/workspaces/permissions/removeMember/removeMember';

export const useRemoveWorkspaceMember = (workspaceId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: removeWorkspaceMember,
    onSuccess: () => {
      // Normally we would invalidate the query, but since it's possible to
      // remove yourself, we remove the query since if you remove yourself,
      // it would no longer be possible to re-query this endpoint.
      return queryClient.removeQueries(workspaceKeys.members(workspaceId));
    },
  });
};
